import _classCallCheck from "babel-runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "babel-runtime/helpers/possibleConstructorReturn";
import _inherits from "babel-runtime/helpers/inherits";
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { ModalPrompt, buttonTypes } from "@rosetta/react-common-ui";
import { actions as audioQualityModalActions } from "./audio-quality-modals-reducer";
import GenericAudioQualityModal from "./GenericAudioQualityModal";

/**
 * This is the dialog that pops up when the SRE hears very loud speech input multiple times in a row.
 *
 * It lets the user choose:
 *  * disable speech,
 *  * re-calibrate speech,
 *  * or continue the learning exercise and ignore the problem.
 *
 */

export var TooLoudModal = function (_PureComponent) {
  _inherits(TooLoudModal, _PureComponent);

  function TooLoudModal() {
    var _temp, _this, _ret;

    _classCallCheck(this, TooLoudModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.render = function () {
      return React.createElement(GenericAudioQualityModal, {
        dataQa: "SreTooLoudModal",
        userRestrictedFromDisableSpeech: _this.props.userRestrictedFromDisableSpeech,
        useLoudAudioWaveIcon: true,
        headerTextLionKey: "sre_audio_quality_modal_too_loud_header_text",
        subHeaderTextLionKey: "sre_audio_quality_modal_too_loud_subheader_text",
        tryAgainAction: _this.props.hideTooLoudModal
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return TooLoudModal;
}(PureComponent);

TooLoudModal.defaultProps = {
  userRestrictedFromDisableSpeech: false
};

TooLoudModal.propTypes = {
  userRestrictedFromDisableSpeech: PropTypes.bool
};

var mapStateToProps = function mapStateToProps(state) {
  return {};
};

var tooLoudActions = {
  hideTooLoudModal: audioQualityModalActions.hideTooLoudModal
};

var TooLoudModalContainer = connect(mapStateToProps, tooLoudActions)(TooLoudModal);

export default TooLoudModalContainer;